module.exports = __webpack_public_path__ + "img/idle-clock.449f0a60.svg";